'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _ChargeV = require('./ChargeV2.js');

var _ChargeV2 = _interopRequireDefault(_ChargeV);

var _OrderItem = require('./OrderItem.js');

var _OrderItem2 = _interopRequireDefault(_OrderItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    /**
     * @return The orderCharges (ChargesV2) that should be added to the order
     */
    getOrderCharges: function getOrderCharges(_ref) {
        var dispatchType = _ref.dispatchType,
            dispatchTime = _ref.dispatchTime,
            orderItems = _ref.orderItems,
            tip = _ref.tip,
            source = _ref.source,
            platform = _ref.platform,
            chargesV2 = _ref.chargesV2,
            timezone = _ref.timezone,
            couponHashCode = _ref.couponHashCode;


        var orderCharges = [];
        var prevOrderCharges = [];

        var _dispatchTime = (0, _moment2.default)(dispatchTime).tz(timezone);

        do {
            prevOrderCharges = orderCharges;

            orderCharges = _lodash2.default.compact(_lodash2.default.map(chargesV2, function (charge) {

                var isApplicable = _ChargeV2.default.isApplicable({
                    charge: charge,
                    deliveryTime: _dispatchTime,
                    deliveryType: dispatchType,
                    orderItems: orderItems,
                    source: source,
                    platform: platform,
                    couponHashCode: couponHashCode
                });

                if (!isApplicable) {
                    if (charge.mandatory && charge.state !== 'closed') {
                        return { chargeId: charge.id, amount: 0 };
                    } else {
                        return null;
                    }
                } else {
                    var amount = _ChargeV2.default.calculateAmount({
                        charge: charge,
                        deliveryTime: _dispatchTime,
                        deliveryType: dispatchType,
                        source: source,
                        tip: tip,
                        platform: platform,
                        orderItems: orderItems,
                        orderCharges: orderCharges,
                        couponHashCode: couponHashCode
                    });
                    if (charge.mandatory || amount != 0) {
                        return {
                            chargeId: charge.id,
                            amount: _ChargeV2.default.calculateAmount({
                                charge: charge,
                                deliveryTime: _dispatchTime,
                                deliveryType: dispatchType,
                                source: source,
                                tip: tip,
                                platform: platform,
                                orderItems: orderItems,
                                orderCharges: orderCharges,
                                couponHashCode: couponHashCode
                            })
                        };
                    } else {
                        return null;
                    }
                }
            }));

            orderCharges = _lodash2.default.sortBy(orderCharges, 'chargeId');
            prevOrderCharges = _lodash2.default.sortBy(prevOrderCharges, 'chargeId');
        } while (!_lodash2.default.isEqual(orderCharges, prevOrderCharges));

        return orderCharges;
    },

    calculateTotalOrder: function calculateTotalOrder(_ref2) {
        var orderItems = _ref2.orderItems,
            orderCharges = _ref2.orderCharges,
            _ref2$dispatchCharge = _ref2.dispatchCharge,
            dispatchCharge = _ref2$dispatchCharge === undefined ? 0 : _ref2$dispatchCharge;

        var price = dispatchCharge;

        _lodash2.default.each(orderItems, function (orderItem) {
            return price += _OrderItem2.default.getTotalPrice({ orderItem: orderItem });
        });
        _lodash2.default.each(orderCharges, function (orderCharge) {
            return price += orderCharge.amount;
        });

        return price;
    },

    sumTaxCharges: function sumTaxCharges(_ref3) {
        var chargesV2 = _ref3.chargesV2,
            orderCharges = _ref3.orderCharges;

        if (!_lodash2.default.find(chargesV2, function (charge) {
            return charge.type === 'tax' && charge.state !== 'closed';
        })) return null;

        var taxOrderCharges = _lodash2.default.filter(orderCharges, function (orderCharge) {
            var charge = _lodash2.default.find(chargesV2, function (c) {
                return c.id === orderCharge.chargeId;
            }) || {};
            return charge.type === 'tax' && charge.state !== 'closed';
        });
        return _lodash2.default.sumBy(taxOrderCharges, 'amount') || 0;
    }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-restaurants-js-sdk/dist/helpers/Order.js
// module id = 895
// module chunks = 0